export default "__VITE_PUBLIC_ASSET__5d057e44__"